import { inject, Injectable, DestroyRef } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RequestStatus } from '@aveespa/common/enums/requests/request.enum';
import { RequestsService } from 'app/modules/requests/services/requests.service';

/**
 * Keeps the native app icon badge in sync with the count of InProgress requests
 * where the current user is the active step assignee.
 *
 * Native only — no-op on web. Eagerly injected from AppComponent.
 */
@Injectable({ providedIn: 'root' })
export class BadgeService {
    private readonly _auth           = inject(Auth);
    private readonly _requestsService = inject(RequestsService);
    private readonly _destroyRef     = inject(DestroyRef);

    constructor() {
        if (!Capacitor.isNativePlatform()) return;

        this._requestsService.getMyRequestsForCurrentUser()
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe((requests) => {
                const uid   = this._auth.currentUser?.uid;
                const count = uid
                    ? requests.filter(
                        r => r.status === RequestStatus.InProgress
                          && r.activeStepAssigneeUid === uid,
                    ).length
                    : 0;

                Badge.set({ count }).catch(() => {});
            });
    }
}
